import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Button, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import Assets from '../../../services/Assets';
import { toast } from 'react-toastify';
import { useAuth } from '../../../Context/Auth/AuthContext';
import Strings from '../../../translations/Translations';
import MediaQuery from 'react-responsive';

const EXPRESS_URL = process.env.REACT_APP_EXPRESS_URL;

export default function VideoStyle(props) {
  const { parentSelectCallback, parentStyle, setParentStyle, showSaveButton, saveButtonCallback, processHashtagStyle } = props;
  const { toggleLoading } = useAuth();

  const [categoriesSet, setCategoriesSet] = useState();
  const [activeCategorySet, setActiveCategorySet] = useState(0);
  const [categories, setCategories] = useState();
  const [catsImages, setCatsImages] = useState();
  const [categoryView, setCategoryView] = useState(false);
  const [activeCategoryName, setActiveCategoryName] = useState();
  const [styles, setStyles] = useState();

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const selectStyle = useCallback((style) => {
    const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
    const backImgLoc = style.backImgLoc;
    const posterSrc = `${backgroundsImgs}${backImgLoc}`;
    const videoSrc = EXPRESS_URL.replace('{id}', style.id);
    style.posterSrc = posterSrc;
    style.videoSrc = videoSrc;

    if (parentSelectCallback) {
      parentSelectCallback();
    }
    if (setParentStyle) {
      setParentStyle(style);
    }
    scrollTop();
  }, [catsImages, parentSelectCallback, setParentStyle]);

  const unselectStyle = useCallback(() => {
    setParentStyle();
  }, [setParentStyle]);

  const renderStyle = useCallback((style, index) => {
    if (style) {
      const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
      const backImgLoc = style.backImgLoc;
      const posterSrc = `${backgroundsImgs}${backImgLoc}`;
      const videoSrc = EXPRESS_URL.replace('{id}', style.id);

      return (
        <Col
          md={4}
          key={`${style.id}_${style.BaName}_${index}`}
          className='mb-3'
        >
          <video
            playsInline=''
            preload='none'
            poster={posterSrc}
            className='cat-style-video-element'
            controls
          >
            <source src={videoSrc} type='video/mp4' />
          </video>
          <div className='text-right'>
            <Button
              outline
              color='secondary'
              onClick={() => selectStyle(style)}
            >
              {Strings('select')}
            </Button>
          </div>
        </Col>
      );
    }
  }, [catsImages, selectStyle]);

  const showStyles = useCallback(async (cat, name) => {
    setActiveCategoryName(name);
    setCategoryView(true);
    setStyles();

    toggleLoading(true);
    let style;

    try {
      style = await Assets.getStyle(cat);
    } catch (err) {
      toast.error(`${Strings('error_while_getting_style')} [ID==04]`);
    }

    if (style) {
      setStyles(style);
    }
    toggleLoading(false);
  }, [toggleLoading, setActiveCategoryName, setCategoryView, setStyles]);

  const renderCategoryCard = useCallback((cat) => {
    if (catsImages && catsImages.its && catsImages.its[cat]) {
      let targetCategory;
      if (categories && categories.its) {
        targetCategory = categories.its.filter((value) => {
          return parseInt(value.id) === cat;
        });
      }

      if (targetCategory && targetCategory[0]) {
        const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
        const src = backgroundsImgs + catsImages.its[cat].img;
        const name = catsImages.its[cat].name;

        return (
          <Col
            lg={3}
            md={4}
            key={cat}
            className='mb-3'
          >
            <img
              className='img-fluid rounded pointer'
              src={src}
              alt={name}
              onClick={() => {
                showStyles(cat, targetCategory[0].la);
                if (processHashtagStyle) {
                  processHashtagStyle(targetCategory[0].la);
                }
              }}
            />
            <p
              className='cat-card-name text-center m-0 pointer'
              onClick={() => {
                showStyles(cat, targetCategory[0].la);
                if (processHashtagStyle) {
                  processHashtagStyle(targetCategory[0].la);
                }
              }}
            >
              {targetCategory[0].la}
            </p>
          </Col>
        );
      }
    }
  }, [catsImages, categories, showStyles, processHashtagStyle]);

  const getCategories = useCallback(async () => {
    toggleLoading(true);
    let categories, generalCategories, catsImages;

    try {
      categories = await Assets.getCategoriesSet();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_categories')} [ID==01]`);
    }

    try {
      generalCategories = await Assets.getCategories();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_categories')} [ID==02]`);
    }

    try {
      catsImages = await Assets.getCatImages();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_categories')} [ID==03]`);
    }

    if (catsImages) {
      setCatsImages(catsImages);
    }
    if (generalCategories) {
      setCategories(generalCategories);
    }
    if (categories && categories.its) {
      const localSet = categories.its;
      localSet[0].title = 'Classic';
      localSet[4].title = 'Modern';
      localSet[5].title = 'Business';

      const newSet = [];
      newSet.push(localSet[1]);
      newSet.push(localSet[2]);
      newSet.push(localSet[3]);
      newSet.push(localSet[0]);
      newSet.push(localSet[4]);
      newSet.push(localSet[5]);
      
      setCategoriesSet(newSet);
    }

    toggleLoading(false);
  }, [setCategoriesSet, setCategories, setCatsImages, toggleLoading]);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  return (
    <Fragment>

      {parentStyle && (
        <Fragment>
          {/* MOBILE VIEW */}
          <MediaQuery maxWidth={767}>
            <ListGroup className='mb-5'>
              <ListGroupItem>
                <Row>
                  <Col xs={6}>
                    <img
                      className='rounded img-fluid'
                      alt={parentStyle.BaName}
                      src={parentStyle.posterSrc}
                    />
                  </Col>
                  <Col xs={6}>
                    <div className='widget-heading'>
                      {parentStyle.BaName}
                    </div>
                    <div className='mb-2'>
                      <div className='badge badge-success'>
                        {Strings('selected_style')}
                      </div>
                    </div>
                    <Button
                      color='danger'
                      outline
                      size='sm'
                      onClick={unselectStyle}
                    >
                      {Strings('unselect')}
                    </Button>
                  </Col>
                </Row>
              </ListGroupItem>
              {showSaveButton && saveButtonCallback && (
                <ListGroupItem>
                  <div className='text-right'>
                    <Button
                      color='primary'
                      onClick={saveButtonCallback}
                    >
                      {Strings('update_style')}
                    </Button>
                  </div>
                </ListGroupItem>
              )}
            </ListGroup>
          </MediaQuery>

          {/* DESKTOP VIEW */}
          <MediaQuery minWidth={768}>
            <ListGroup className='mb-5'>
              <ListGroupItem>
                <div className='widget-content p-0'>
                  <div className='widget-content-wrapper'>
                    <div className='widget-content-left mr-3'>
                      <img
                        width={160}
                        className='rounded'
                        alt={parentStyle.BaName}
                        src={parentStyle.posterSrc}
                      />
                    </div>
                    <div className='widget-content-left'>
                      <div className='widget-heading'>
                        {parentStyle.BaName}
                      </div>
                      <div className=''>
                        <div className='badge badge-success'>
                          {Strings('selected_style')}
                        </div>
                      </div>
                    </div>
                    <div className='widget-content-right'>
                      <Button
                        color='danger'
                        outline
                        size='sm'
                        onClick={unselectStyle}
                      >
                        {Strings('unselect')}
                      </Button>
                    </div>
                  </div>
                </div>
              </ListGroupItem>
              {showSaveButton && saveButtonCallback && (
                <ListGroupItem>
                  <div className='text-right'>
                    <Button
                      color='primary'
                      onClick={saveButtonCallback}
                    >
                      {Strings('update_style')}
                    </Button>
                  </div>
                </ListGroupItem>
              )}
            </ListGroup>
          </MediaQuery>
        </Fragment>
      )}

      {!categoryView && (
        <Fragment>
          <div className='text-center mb-3'>
            {categoriesSet && categoriesSet.length > 0 && categoriesSet.map((value, index) => (
              <Button
                key={index}
                outline
                className='mb-2 mr-2'
                color='primary'
                active={activeCategorySet === index}
                onClick={() => setActiveCategorySet(index)}
              >
                {value.title}
              </Button>
            ))}
          </div>

          {categoriesSet && categoriesSet.length > 0 && categoriesSet.map((value, index) => (
            <Fragment key={index}>
              {activeCategorySet === index && (
                <Row>
                  {value.cats && value.cats.map((cat) => renderCategoryCard(cat))}
                </Row>
              )}
            </Fragment>
          ))}
        </Fragment>
      )}

      {categoryView && (
        <Fragment>
          <Row className='mb-2'>
            <Col>
              <span
                className='pointer p-3 close-button-styles align-middle'
                onClick={() => setCategoryView(false)}
              >
                <i className='lnr-cross'> </i>
              </span>
              <span
                className='align-middle name-select-styles'
              >
                {activeCategoryName} {Strings('styles')}
              </span>
            </Col>
          </Row>

          <Row>
            {styles && styles.length > 0 && styles.map((value, index) => renderStyle(value, index))}
          </Row>
        </Fragment>
      )}

    </Fragment>
  );
}
